export default __webpack_public_path__ + "static/legate-1f61515187ac3e77f1d4f840ad5aadc1.jpg";